<div class="flex flex-column align-items-center text-center gap-2 border-1 border-round border-green-300 bg-green-50 p-3 mt-2 font-semibold text-green-700">
    <i class="pi pi-check-circle text-xl text-green-600"></i>
    <span>{{ message }}</span>
</div>